













import {
  Component,
  Emit,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class CharacterIconSizeInput extends Vue {
  @Prop() value?: number;

  @Emit('input')
  emitInput(value: number | null) {}

  onInput(value?: string) {
    const number = Number(value);
    this.emitInput(Number.isNaN(number) ? null : number);
  }
}
